// extracted by mini-css-extract-plugin
export default {"wrapper":"list_wrapper__ldvpG","button":"list_button__LcB1i","container":"list_container__0Cugv","double":"list_double__tPufj","row":"list_row__9i67O"};